<template>
    <main class="container">
        <!-- Banner轮播图 -->
        <section class="banner">
            <el-carousel indicator-position="outside" height="100%" :interval="5000" arrow="always" motion-blur="true">
                <el-carousel-item v-for="(banner, index) in banners" :key="index">
                    <div class="carousel-item"
                         :style="{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${banner.image})` }">
                        <div class="carousel-content">
                            <h2>{{ banner.title }}</h2>
                            <p>{{ banner.description }}</p>
                            <button class="shop-now-btn" @click="toShop">ACHETER MAINTENANT</button>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </section>

        <!-- 商品展示 - 标准网格 -->
        <section class="products-section">
            <div class="section-title" style="display: flex; align-items: center">
                <div class="big-title">
                    <span class="big-title-art">R</span>ECOMMANDÉ<br />
                    PRODUIT
                </div>

                <div style="flex:1;">
                    <el-button class="section-btn" @click="toShop">TOUT VOIR</el-button>
                </div>
            </div>

            <Product :products="topProducts"></Product>

            <PeoductIntroduce :showItems="['1','2','3']" :products="products"></PeoductIntroduce>
        </section>

        <Subscribe></Subscribe>

        <div class="video-player-container">
            <div class="video-player">
                <div v-if="!isPlaying"
                     class="background-container"
                     :style="{ backgroundImage: `url(${thumbnail})` }"
                     @click="playVideo"
                     @mouseover="hover = true"
                     @mouseleave="hover = false">
                    <div class="play-button">
                        <i class="fas fa-play"></i>
                    </div>
                </div>

                <video v-else
                       ref="videoPlayer"
                       class="video-element"
                       controls
                       autoplay
                       :poster="thumbnail">
                    <source :src="videoSource" type="video/mp4">
                    您的浏览器不支持HTML5视频播放
                </video>
            </div>
        </div>
    </main>

    <el-dialog v-model="dialogVisible"
               title=""
               width="668px">
        <div  class="login-container">
            <div  class="login-item1">
                <div style="margin: 9.32292% 3.07692% 0% 8.89912%; font-size: 18px; color: rgb(35, 35, 35);">HEUREUX DE VOUS REVOIR</div>
                <div style="margin: 4.27083% 3.07692% 0% 8.89912%;font-size:34px;font-weight:bold;">
                    MERCI POUR VOTRE VISITE
                </div>
                <div style="margin: 4.27083% 3.07692% 0% 8.89912%; font-size: 16px; line-height: 1.5; color: rgb(121, 121, 121);">
                    INSCRIVEZ-VOUS À NOTRE<br />
                    NEWSLETTER ET RESTEZ INFORMÉ(E)S
                </div>
                <div style="margin: 34px;">
                    <el-input v-model="email" placeholder="L'e-mail" style="height: 40px;"></el-input>
                </div>
                <div style="margin:0 20px;">
                    <button class="submit" @click="closeLogin">VALIDER</button>
                </div>
            </div>
            <div  class="login-item2">
                <img src="../src/assets/home/login.jpg"  />
            </div>
        </div>
    </el-dialog>

</template>

<script>
    import Product from '../src/components/Product.vue'
    import Subscribe from '../src/components/Subscribe.vue'
    import PeoductIntroduce from '../src/components/PeoductIntroduce.vue'

    export default {
        name: 'App',
        data() {
            return {
                dialogVisible: false,
                searchQuery: '',
                email: '',
                banners: [
                    {
                        image: require(`@/assets/home/banner04.jpg`),
                        title: 'OBTENEZ LA PEAU QUE VOUS VOULEZ RESSENTIR.',
                        description: ''
                    },
                    {
                        image: require(`@/assets/home/banner05.jpg`),
                        title: 'JUSQU\'À - 30 %',
                        description: 'MAÎTRISER L\'ART D\'UNE PEAU SAINE'
                    },
                    //{
                    //    image: require(`@/assets/home/banner03.jpg`),
                    //    title: 'GET THE SKIN YOU WANT TO FEEL',
                    //    description: 'SKIN CARE'
                    //}
                ],
                topProducts: [],
                products: [
                ],
                featuredProducts: [

                ],
                isPlaying: false,
                thumbnail: require(`@/assets/home/video_thumbnail.jpg`),
                videoSource: require(`@/assets/home/video.mp4`),
            }
        },
        components: {
            Subscribe,
            Product,
            PeoductIntroduce
        },
        mounted() {
            let isLogin = this.getCache('isLogin');
            if (isLogin != '1') {
                this.dialogVisible = true;
            }

            this.loadData();
        },
        methods: {
            playVideo() {
                this.isPlaying = true;
                // 确保视频元素已加载并播放
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                });
            },
            toShop() {
                window.open('/Shop');
            },
            async loadData() {
                try {
                    const response = await fetch('/products.json'); // 注意路径应为相对于public文件夹的路径，或者使用绝对路径如`/data/file.json`
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    this.products = data;

                    for (var i = 0; i < this.products.length; i++) {
                        let num = this.products[i].image;
                        const image = require(`@/assets/projects/${num}.jpg`);
                        this.products[i].image = image;

                        if (i == 0 || i == 1 || i == 3 || i == 9) {
                            this.topProducts.push(this.products[i]);
                        }
                    }
                } catch (error) {
                    console.error('There has been a problem with your fetch operation:', error);
                }
            },
            closeLogin() {
                this.dialogVisible = false;
                this.setCache('isLogin', '1');
            },
            // 设置缓存
            setCache(key, value) {
                const now = new Date();
                const expiry = new Date(now.getTime() + 20 * 60 * 60 * 1000); // 1天后

                const cacheData = {
                    value: value,
                    expiry: expiry.getTime()
                };

                localStorage.setItem(key, JSON.stringify(cacheData));
            },
            // 获取缓存
            getCache(getKey) {
                const item = localStorage.getItem(getKey);

                if (item == null) {
                    return '';
                }

                const cacheData = JSON.parse(item);
                const now = new Date();

                if (now.getTime() > cacheData.expiry) {
                    localStorage.removeItem(getKey);

                    return '';
                } else {
                    return cacheData.value;
                }
            }
        }
    }
</script>
<style>
    .el-dialog {
        padding: 0 !important;
    }

    .el-dialog__header {
        padding: 0;
    }

    .centered-dialog {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .el-dialog {
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }


    .el-carousel__arrow {
        width: 60px !important;
        height: 60px !important;
        border-radius: 20px !important;
    }

    .login-container {
        display: flex;
        color: black;
    }

    .login-item1 {
        flex: 6;
    }

    .login-item2 {
        flex: 4;
    }
        .login-item2 img {
            height: 100%;
            width: 100%
        }

    @media (max-width: 768px) {
        .el-carousel__arrow {
            display: none;
        }

        .login-container {
            flex-wrap: wrap;
            flex-direction: column-reverse;
        }

        .login-item1, .login-item2{
            width:100%;
            flex:auto;
        }

            .login-item1{
                margin-bottom:20px;
            }

            .login-item2 {
                text-align: center;
                padding-top:10px
            }

            .login-item2 img {
                height: 40vh;
                width: auto
            }
    }
</style>
<style scoped>

    .video-player-container {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        height: calc(100vh - 84px);
        justify-content: center;
    }

    .video-player {
        width: 100%;
        max-width: 100%;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
        position: relative;
        background: #000;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    /*.video-player:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
        }*/

    .background-container {
        width: 100%;
        height: calc(100vh - 84px);
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        transition: background-position 0.24s ease;
    }

        .background-container::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        .background-container:hover::before {
            opacity: 1;
        }

    .play-button {
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        transition: transform 0.24s ease, background-color 0.24s ease, box-shadow 0.24s ease;
        transform: scale(0.95);
    }

    .background-container:hover .play-button {
        transform: scale(1.05);
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 30px rgba(255, 255, 255, 0.6);
    }

    .play-button i {
        font-size: 32px;
        color: #e74c3c;
        margin-left: 5px;
    }

    .video-element {
        width: 100%;
        height: calc(100vh - 84px);
        display: block;
        object-fit: cover;
    }

    .video-info {
        padding: 20px;
        background: linear-gradient(to right, #2c3e50, #4a69bd);
    }

    .video-title {
        font-size: 1.5rem;
        margin-bottom: 10px;
    }

    .video-description {
        opacity: 0.85;
        line-height: 1.5;
    }


    .el-carousel__arrow {
        width: 81px !important;
        height: 80px !important;
        border-radius: 20px !important;
    }



    .instructions {
        max-width: 800px;
        margin: 40px auto 0;
        background: white;
        padding: 20px;
        border-radius: 15px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }

        .instructions h2 {
            color: #2575fc;
            margin-bottom: 15px;
            text-align: center;
        }

        .instructions p {
            margin-bottom: 10px;
            line-height: 1.6;
            color: #444;
        }

    @media (max-width: 768px) {
        .gallery {
            flex-direction: column;
            align-items: center;
        }

        .image-card {
            width: 100%;
            max-width: 350px;
        }
    }

    .submit {
        width: 100%;
        height: 40px;
        background: #000000;
        color: white;
        border: none;
        padding: 15px 0;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

        .submit:hover {
            background: #433c40;
        }

    .container {
        margin: 0 auto;
        padding: 0;
        overflow-x: hidden;
        overflow-x: clip;
    }

    /* Banner区域样式 */
    .banner {
        position: relative;
        height: 100vh;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .el-carousel {
        height: 100%;
    }

    .carousel-item {
        height: 100%;
        background-size: cover;
        background-position: center;
        display: flex;
        align-items: center;
    }

    .carousel-content {
        padding: 0 50px;
        width: 100%;
        text-align: center;
        color: #fff;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }

        .carousel-content h2 {
            font-size: 42px;
            margin-bottom: 20px;
        }

        .carousel-content p {
            font-size: 18px;
            margin-bottom: 30px;
        }

    .shop-now-btn {
        background-color: #ffffff4a;
        color: #bebebe;
        border: none;
        padding: 12px 30px;
        font-size: 16px;
        border-radius: 30px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

        .shop-now-btn:hover {
            background-color: #d42a7a;
        }

    /* 商品区域样式 */
    .section-title {
        text-align: left;
        margin: 80px;
        position: relative;
    }

        .section-title h2 {
            font-size: 50px;
            color: #333;
            display: inline-block;
            padding-bottom: 10px;
            position: relative;
        }

            .section-title h2:after {
                content: '';
                position: absolute;
                width: 75%;
                height: 1px;
                background-color: #000000;
                bottom: 0;
                left: 25%;
            }



    .quick-view {
        background: #fff;
        color: #e83e8c;
        border: none;
        padding: 10px 20px;
        border-radius: 20px;
        cursor: pointer;
        font-weight: 500;
    }

    .product-info {
        padding: 20px;
        text-align: center;
    }

    .product-name {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 30px;
        color: #333;
    }

    .product-price {
        position: relative;
        margin-bottom: 20px;
    }

    .price {
        font-size: 20px;
        font-weight: bold;
        color: #5c5c5c;
    }

    .add-to-cart {
        background-color: #f8f8f8;
        border: none;
        width: 40px;
        height: 40px;
        borderRadius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;
        position: absolute;
        right: 10px;
        bottom: 0px;
    }

        .add-to-cart:hover {
            background-color: #e83e8c;
            color: white;
        }

    .section-btn {
        width: 200px;
        height: 60px;
        border-radius: 40px;
        float: right;
        font-size: 20px;
    }

    /* 响应式设计 */
    @media (max-width: 768px) {
        .nav-menu {
            display: none;
        }

        .carousel-content {
            max-width: 80%;
        }

            .carousel-content h2 {
                font-size: 28px;
            }

        .banner, .carousel-item {
            height: 200px;
        }

        .double-column {
            grid-template-columns: 1fr;
        }

        .large-product-card {
            flex-direction: column;
        }

        .large-product-image, .large-product-info {
            width: 100%;
        }

        .large-product-image {
            height: 250px;
        }

        .full-width-content {
            flex-direction: column;
            height: auto;
        }

        .full-width-image, .full-width-info {
            width: 100%;
        }

        .full-width-image {
            height: 250px;
        }



        .section-title {
            margin: 10px;
        }

        .section-btn {
            width: 100px;
            height: 30px;
            border-radius: 40px;
            float: right;
            font-size: 12px;
        }

        .video-player-container, .background-container, .video-element {
            height: 240px;
        }
    }
</style>
